import { get } from '../services/Generic.api';

export const fetch_category = async (clientId) => {
  try {
    return await get(`/category/?client=${clientId}`);
  } catch (error) {
    console.error(`Erro ao buscar dados do cliente ${clientId}:`, error);
    throw error;
  }
};
